export const activePersonForImportedFile = (data) => {
  const clusterId = data.id;
  const guestIds = data.map(d => d && d.id);
  const guestFirstName = data.map(d => d && d.map(item => item && item.firstName).filter(arr => arr).toString());
  const guestLastName = data.map(d => d && d.map(item => item && item.lastName).filter(arr => arr).toString());
  const combinedFirstNameAndLastName = guestFirstName.map((e, i) => ({ firstName: e, lastName: guestLastName[i] }));
  const objectToSend = { clusterId, id: guestIds, combinedFirstNameAndLastName };
  return objectToSend;
};



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/steps/cabin/activePersonForImportedFile.js